import React from "react";
import Privacidade from "./pages/Privacidade";
import { ui } from "./ui";

function TopBar() {
  return (
    <header style={ui.top}>
      <a href="/" style={ui.brand}>
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="CarMatcher"
          style={ui.logo}
        />
        <div style={ui.brandText}>
          <div style={ui.brandName}>CarMatcher</div>
          <div style={ui.brandTag}>Match de carros, simples e rápido</div>
        </div>
      </a>

      <a href="/privacidade" style={ui.buttonSecondary}>
        Política
      </a>
    </header>
  );
}

function Home() {
  const appStoreLink = "https://apps.apple.com/us/app/carmatcher/id6757449015";
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.carmatcher.app";

  const badgeWrap = {
    display: "flex",
    gap: 14,
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: 18,
  };

  const badgeLink = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 56,
    padding: "10px 14px",
    borderRadius: 16,
    backgroundColor: "rgba(17,24,39,0.04)",
    border: "1px solid rgba(17,24,39,0.08)",
    boxShadow: "0 10px 22px rgba(17,24,39,0.10)",
    textDecoration: "none",
    transition: "transform 120ms ease, box-shadow 120ms ease",
  };

  const badgeImg = {
    height: 36,
    width: "auto",
    display: "block",
  };

  const onEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 14px 28px rgba(17,24,39,0.14)";
  };

  const onLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0px)";
    e.currentTarget.style.boxShadow = "0 10px 22px rgba(17,24,39,0.10)";
  };

  return (
    <div style={ui.page}>
      <div style={ui.container}>
        <section style={ui.card}>
          <h1 style={ui.h1}>Baixe o CarMatcher</h1>

          <p style={ui.lead}>
            O jeito inteligente de trocar veículos. Cadastre seu carro, deslize
            para curtir, faça match e negocie direto com outras pessoas.
          </p>

          <p style={ui.small}>
            Quando houver match, você pode desbloquear o chat para combinar a
            negociação. Também existe Super Like para iniciar conversa sem
            esperar o match.
          </p>

          <div style={badgeWrap}>
            <a
              href={appStoreLink || "#"}
              onClick={(e) => {
                if (!appStoreLink) e.preventDefault();
              }}
              aria-label="Baixar na App Store"
              style={badgeLink}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/appstore4.png`}
                alt="Download on the App Store"
                style={badgeImg}
              />
            </a>

            <a
              href={playStoreLink || "#"}
              onClick={(e) => {
                if (!playStoreLink) e.preventDefault();
              }}
              aria-label="Baixar no Google Play"
              style={badgeLink}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/googleplay4.png`}
                alt="Get it on Google Play"
                style={badgeImg}
              />
            </a>
          </div>

          <div style={ui.hr} />

          <div style={ui.sectionTitle}>Contato</div>
          <p style={ui.small}>suporte@carmatcher.com.br</p>

          <div style={ui.footer}>© {new Date().getFullYear()} CarMatcher</div>
        </section>

        <div style={{ marginTop: 18 }}>
          <TopBar />
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const path = window.location.pathname;
  if (path === "/privacidade") return <Privacidade />;
  return <Home />;
}
